import Vue from 'vue'
import singleSpaVue from 'single-spa-vue'
import vuetify from './plugins/vuetify'
import App from './App.vue'
import VueRouter from 'vue-router'
import { Utils } from '@ciitizen/component-library'
import store from './store'
import router from './router'
import Vuelidate from 'vuelidate'

export { default as Store } from './store/login'

// import common components/functions from library components
import './util/filter'
import '@fortawesome/fontawesome-pro/css/fontawesome.min.css'
import '@fortawesome/fontawesome-pro/css/solid.min.css'
import '@fortawesome/fontawesome-pro/css/regular.min.css'
import '@fortawesome/fontawesome-pro/css/light.min.css'

Vue.use(VueRouter)
Vue.use(Vuelidate)

Vue.config.productionTip = false

Vue.config.devtools = process.env.ENV !== 'prod'

import toggle from './plugins/toggle'
Vue.use(toggle)

const vueLifecycles = singleSpaVue({
  Vue,
  appOptions: {
    el: '#auth',
    render(h) {
      return h(App, {
        props: {
          // single-spa props are available on the "this" object. Forward them to your component as needed.
          // https://single-spa.js.org/docs/building-applications#lifecyle-props
          // if you uncomment these, remember to add matching prop definitions for them in your App.vue file.
          /*
          name: this.name,
          mountParcel: this.mountParcel,
          singleSpa: this.singleSpa,
          */
        }
      })
    },
    vuetify,
    router,
    store
  }
})

export const bootstrap = vueLifecycles.bootstrap

export const mount = [
  () => {
    Utils.createComponentRootElement('auth')
    return Promise.resolve()
  },
  vueLifecycles.mount
]

export const unmount = vueLifecycles.unmount
